/**
 * The **Cookie Bar** implementation is supposed to be injected by Google Tag
 * Manager.
 *
 * @module
 */
import {window} from '@acng/frontend-bounty/dom/window.js';
import {click, NamespaceController, reactive} from 'nova';

/**
 * @example
 *
 * ```html
 * <!--@ ${settings.cookie} -->
 * <section>
 *   <!--@ ${click} -->
 *   <button>Show the cookie bar</button>
 * </section>
 * ```
 */
class CookieBar extends NamespaceController {
  /**
   * @example
   *
   * ```html
   * <!--@ ${ok} -->
   * <strong>The cookie bar is available.</strong>
   * ```
   */
  @reactive accessor ok = true;

  /**
   * @example
   *
   * ```html
   * <!--@ ${error} -->
   * <strong>The cookie bar is <em>not</em> available.</strong>
   * ```
   */
  @reactive accessor error = false;

  /**
   * @example
   *
   * ```html
   * <!--@ ${click} -->
   * <button>Show the cookie bar</button>
   * ```
   */
  @click click() {
    /**
     * Show the cookie bar.
     *
     * @type {(() => void) | undefined}
     */
    // @ts-ignore Definitely not typed.
    const show = window.CookieScript?.instance?.show;

    if (!show) {
      this.ok = false;
      this.error = true;

      return;
    }

    show();
  }
}

export {CookieBar};
